var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilePdfPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.964,
    height: 22.619,
    viewBox: "0 0 16.964 22.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-pdf",
    "data-name": "Icon awesome-file-pdf",
    d: "M8.036,11.314a4.262,4.262,0,0,1-.088-2.072C8.319,9.242,8.283,10.872,8.036,11.314ZM7.961,13.4a20.385,20.385,0,0,1-1.255,2.77A16.267,16.267,0,0,1,9.485,15.2,5.723,5.723,0,0,1,7.961,13.4ZM3.8,18.912c0,.035.583-.239,1.542-1.776A6.106,6.106,0,0,0,3.8,18.912ZM10.956,7.068h6.008v14.49a1.058,1.058,0,0,1-1.06,1.06H1.06A1.058,1.058,0,0,1,0,21.558V1.06A1.058,1.058,0,0,1,1.06,0H9.9V6.008A1.063,1.063,0,0,0,10.956,7.068Zm-.353,7.59a4.434,4.434,0,0,1-1.886-2.377A6.35,6.35,0,0,0,8.99,9.445a1.106,1.106,0,0,0-2.112-.3,7.346,7.346,0,0,0,.358,3.4,41.484,41.484,0,0,1-1.8,3.79s0,0-.009,0c-1.2.614-3.251,1.966-2.408,3a1.373,1.373,0,0,0,.95.442c.791,0,1.577-.8,2.7-2.73a25.181,25.181,0,0,1,3.49-1.025,6.7,6.7,0,0,0,2.827.861,1.144,1.144,0,0,0,.87-1.917c-.614-.6-2.4-.429-3.251-.318ZM16.655,4.639,12.325.309A1.059,1.059,0,0,0,11.574,0h-.265V5.655h5.655V5.385A1.057,1.057,0,0,0,16.655,4.639ZM13.381,15.917c.181-.119-.11-.526-1.891-.4C13.129,16.217,13.381,15.917,13.381,15.917Z",
    fill: "#EE579C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilePdfPink);
export default __webpack_public_path__ + "static/media/icon-file-pdf-pink.1193c59ddaabfb2bf9423784077371c0.svg";
export { ForwardRef as ReactComponent };